<template>
    <Tree
        :tree-items="treeItemsMenus"
        :multiple-expandable="true"
        :auto-indent="true"
        :auto-indent-width="10"
        class="tree-container"
    >
        <template #internal="{ node, depth, toggle }">
            <div class="menu-wrapper cursor" @click="toggle">
                <div class="menu-text-style">└ {{ node.title }}</div>
                <div class="menu-info-desc">
                    <div v-if="isReorderDepth(depth)" class="menu-moving-arrow-wrapper">
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node, 'up') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node, 'up')"
                            @click.stop="moveArrowButtonClick(node, 'up')"
                        >
                            mdi-arrow-up-bold-box-outline
                        </v-icon>
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node, 'down') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node, 'down')"
                            @click.stop="moveArrowButtonClick(node, 'down')"
                        >
                            mdi-arrow-down-bold-box-outline
                        </v-icon>
                    </div>
                    <v-icon
                        v-if="isPlusDepth(depth)"
                        small
                        class="plus-button-style"
                        @click.stop="plusButtonClick(node, depth)"
                    >
                        mdi-plus
                    </v-icon>
                </div>
            </div>
        </template>

        <template #leaf="{ node, depth }">
            <div
                class="menu-wrapper cursor"
                @click="manualClick(node, depth)"
                :class="clickManualBackground(node, depth)"
            >
                <div class="menu-text-style">└ {{ node.title }}</div>
                <div class="menu-info-desc">
                    <div v-if="isReorderDepth(depth)" class="menu-moving-arrow-wrapper">
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node, 'up') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node, 'up')"
                            @click.stop="moveArrowButtonClick(node, 'up')"
                        >
                            mdi-arrow-up-bold-box-outline
                        </v-icon>
                        <v-icon
                            v-if="node.manualId !== -1"
                            small
                            :class="manualStatus(node, 'down') && 'menu-moving-arrow'"
                            :color="arrowMenuDisable(node, 'down')"
                            @click.stop="moveArrowButtonClick(node, 'down')"
                        >
                            mdi-arrow-down-bold-box-outline
                        </v-icon>
                    </div>
                    <v-icon
                        v-if="isPlusDepth(depth)"
                        small
                        class="plus-button-style"
                        @click.stop="plusButtonClick(node, depth)"
                    >
                        mdi-plus
                    </v-icon>
                </div>
            </div>
        </template>
    </Tree>
</template>

<script>
/**
 * 모바일 메뉴얼 전용 트리 UI.
 * - NewManualTreeMenuSlot.vue 를 import/extends 하지 않음 (별도 컴포넌트).
 * - 트리 뼈대만 공용 Tree.vue 사용 (newManual/TreeMenuSlot — 프레젠테이션 공유).
 * - 형제/순서 계산은 manualTreeMenuHelpers.js (PC NewManual 슬롯과 파일 분리).
 */
import Tree from "@/views/newManual/TreeMenuSlot/Tree";
import { findReorderNeighbor } from "@/views/mobileManual/manualTreeMenuHelpers";

export default {
    name: "MobileManualTreeMenuSlot",
    components: { Tree },
    props: {
        treeItemsMenus: {
            type: Array,
            default: () => [],
        },
        menus: {
            type: Array,
            default: () => [],
        },
        clickMenuId: {
            type: Number,
            default: undefined,
        },
    },
    methods: {
        isPlusDepth(depth) {
            return depth === 1 || depth === 2;
        },
        isSelectDepth(depth) {
            return depth === 2 || depth === 3;
        },
        isReorderDepth(depth) {
            return depth === 2 || depth === 3;
        },
        arrowMenuDisable(manual, arrow) {
            let arrowButtonColor = "#cccccc";
            const menuStatus = this.manualStatus(manual, arrow);
            arrowButtonColor = menuStatus ? "#000000" : arrowButtonColor;
            return arrowButtonColor;
        },
        manualStatus(manual, arrow) {
            return findReorderNeighbor(manual, arrow, this.menus);
        },
        clickManualBackground(manual, depth) {
            if (!this.isSelectDepth(depth)) return;
            return (
                (manual.manualId === this.clickMenuId || manual.manualId === -1) &&
                "click-manual-background"
            );
        },
        plusButtonClick(clickMenu, depth) {
            const isBlankManualSameMenu = () => {
                if (!clickMenu.children) return true;
                return clickMenu.children.every((manual) => manual.manualId !== -1);
            };
            if (!isBlankManualSameMenu()) {
                this.$alert("작성 중인 신규 메뉴를 먼저 저장하거나, 목록을 새로고침한 뒤 다시 시도해 주세요.");
                return;
            }
            this.$emit("moving-write-detail", clickMenu, depth);
        },
        manualClick(clickMenu, depth) {
            if (this.isSelectDepth(depth)) {
                this.$emit("moving-select-detail", clickMenu);
            }
        },
        moveArrowButtonClick(clickMenu, arrow) {
            const menuStatus = this.manualStatus(clickMenu, arrow);
            if (!menuStatus) return;
            this.$emit("moving-manual-rq", clickMenu, menuStatus);
        },
    },
};
</script>

<style scoped>
.cursor {
    cursor: pointer;
}
.cursor:hover {
    background: #ddd;
}
.menu-info-desc {
    display: flex;
    align-items: center;
}
.menu-wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
.tree-container {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
}
.plus-button-style {
    cursor: pointer;
    margin-right: 5px;
}
.plus-button-style:hover {
    color: #0575E6;
}
.menu-moving-arrow-wrapper {
    margin-right: 5px;
}
.menu-text-style {
    font-size: 12px;
}
.menu-moving-arrow {
    cursor: pointer;
}
.menu-moving-arrow:hover {
    color: #0575E6 !important;
}
.click-manual-background {
    background-color: #dcedfd;
    border-radius: 3px;
}
</style>
